var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-tabs",
        { staticClass: "mb-1" },
        [
          _c("b-tab", {
            attrs: { title: _vm.$t("cancellation.policies") },
            on: {
              click: function ($event) {
                return _vm.$router.push("/cancellations/policies")
              },
            },
          }),
          _c("b-tab", {
            attrs: { title: _vm.$t("cancellation.product_rules"), active: "" },
          }),
          _c("b-tab", {
            attrs: { title: _vm.$t("cancellation.requests") },
            on: {
              click: function ($event) {
                return _vm.$router.push("/cancellations/requests")
              },
            },
          }),
        ],
        1
      ),
      _c("vx-card", { staticClass: "mb-2" }, [
        _c("small", { staticClass: "text-muted" }, [
          _vm._v(_vm._s(_vm.$t("cancellation.inherit_hint"))),
        ]),
      ]),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          hide_actions: true,
          route_name: "product_cancellation_rules",
          order_column: "id",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID"),
                ]),
                _c("vs-th", { key: "product" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.product"))),
                ]),
                _c("vs-th", { key: "policy" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.applied_policy"))),
                ]),
                _c("vs-th", { key: "reschedule" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.reschedule"))),
                ]),
                _c("vs-th", { key: "origin" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.origin_rule"))),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.id))]),
                    ]),
                    _c("vs-td", { key: "product", attrs: { width: "30%" } }, [
                      _c("div", [
                        _vm._v(_vm._s(tr.product ? tr.product.name : "—")),
                      ]),
                    ]),
                    _c("vs-td", { key: "policy", attrs: { width: "35%" } }, [
                      _c("div", [
                        _vm._v(" " + _vm._s(_vm.policyLabel(tr)) + " "),
                        tr.overrides && tr.overrides.fixed_fee
                          ? _c("span", [
                              _vm._v(
                                " · " +
                                  _vm._s(_vm.$t("cancellation.fixed_fee")) +
                                  " " +
                                  _vm._s(
                                    _vm.formatValue(tr.overrides.fixed_fee)
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "reschedule", attrs: { width: "15%" } },
                      [_c("div", [_vm._v(_vm._s(_vm.rescheduleLabel(tr)))])]
                    ),
                    _c(
                      "vs-td",
                      { key: "origin", attrs: { width: "15%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: {
                              transparent: "",
                              color:
                                tr.policy_id || tr.overrides
                                  ? "primary"
                                  : "secondary",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  tr.policy_id || tr.overrides
                                    ? _vm.$t(
                                        "cancellation.origin_rule_.override"
                                      )
                                    : _vm.$t(
                                        "cancellation.origin_rule_.inherit"
                                      )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }